import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { AiOutlineSave } from 'react-icons/ai'

import { Modal as AntModal } from 'reactstrap'

import { CreateFormTab } from './tab'
import { PersonalInfo } from './personal-info'
import { CompanyInfo } from './company-info'
import { MovementInfo } from './movement-info'
import { PrivilegeRoleInfo } from './privilege-role'

import { CloseIcon } from '../../icons'
import { Button } from '../../buttons'
import { employeeSchema } from '../schema/personal-schema'
import { employeeMovementSchema } from '../schema/movement-schema'
import { selectList } from '../types'
import { FONTS } from '../../../constants'

export const CreateForm = props => {
  const {
    isCreate,
    setIsCreate,
    _companys,
    _lobs,
    _positions,
    _departments,
    _divisions,
    _teams,
    employeeList,
    createEmployee,
  } = props

  const [activeTab, setActiveTab] = useState(0)
  const [detailState, setDetailState] = useState({})
  const [invalid, setInvalid] = useState({})

  useEffect(() => {
    const requiredFields = {}
    const personalKeys = Object.keys(employeeSchema)
    const movementKeys = Object.keys(employeeMovementSchema)
    personalKeys.map(key => {
      if (employeeSchema[key].required) {
        requiredFields[key] = true
      }
      return key
    })
    movementKeys.map(key => {
      if (employeeMovementSchema[key].required) {
        requiredFields[key] = true
      }
      return key
    })
    setInvalid(requiredFields)
  }, [])

  const handleClickTab = tab => {
    setActiveTab(tab)
  }

  const handleInputPersonalData = (e, name) => {
    if (selectList.indexOf(name) > -1) {
      setDetailState({ ...detailState, [name]: e.value })
    } else if (name === 'adjust_after_complete') {
      setDetailState({ ...detailState, [e.target.name]: e.target.checked })
    } else {
      setDetailState({ ...detailState, [name]: e })
    }
    if (employeeSchema[name].required
      && (e === '' || (e && e.value === '') || e === null)) {
      setInvalid({ ...invalid, [name]: true })
    } else if (invalid[name] && !(e === '' || e.value === '')) {
      const _invalid = { ...invalid }
      delete _invalid[name]
      setInvalid(_invalid)
    }
  }

  const handleInputMovementData = (e, name) => {
    if (name === 'company_id') {
      setDetailState({
        ...detailState,
        [name]: e.value,
        lob_id: '',
        department_id: '',
      })
    } else if (name === 'lob_id') {
      setDetailState({
        ...detailState,
        [name]: e.value,
        department_id: '',
      })
    } else if (selectList.indexOf(name) > -1) {
      setDetailState({ ...detailState, [name]: e.value })
    } else {
      setDetailState({ ...detailState, [name]: e })
    }
    if (employeeMovementSchema[name].required
      && (e === '' || (e && e.value === '') || e === null)) {
      setInvalid({ ...invalid, [name]: true })
    } else if (invalid[name] && !(e === '' || e.value === '')) {
      const _invalid = { ...invalid }
      delete _invalid[name]
      if (name === 'hiring_date') {
        delete _invalid['hiring_date']
      }
      setInvalid(_invalid)
    }
  }

  const handleCheckbox = e => {
    setDetailState({ ...detailState, [e.target.name]: e.target.checked })
  }

  const resetState = () => {
    setDetailState({})
    setInvalid({})
  }

  return (
    <Modal
      isOpen={ isCreate }
      toggle={ () => {
        resetState()
        setIsCreate(false)
      } }
    >
      <ModalHeader>
        <Header>Create Employee</Header>
        <CloseIcon
          onClick={ () => {
            resetState()
            setIsCreate(false)
          } }
        />
      </ModalHeader>
      <CreateFormTab
        activeTab={ activeTab }
        handleClickTab={ handleClickTab }
      />
      { activeTab === 0 &&
        <PersonalInfo
          emp={ detailState }
          invalid={ invalid }
          handleInput={ handleInputPersonalData }
        />
      }
      { activeTab === 1 &&
      <CompanyInfo
        emp={ detailState }
        invalid={ invalid }
        users={ employeeList }
        handleInput={ handleInputPersonalData }
      />
      }
      { activeTab === 2 &&
        <MovementInfo
          emp={ detailState }
          _lobs={ _lobs }
          _teams={ _teams }
          _companys={ _companys }
          _divisions={ _divisions }
          _positions={ _positions }
          _departments={ _departments }
          invalid={ invalid }
          handleInput={ handleInputMovementData }
        />
      }
      { activeTab === 3 &&
        <PrivilegeRoleInfo
          emp={ detailState }
          handleCheckbox={ handleCheckbox }
        />
      }
      <Footer>
        <ButtonGroup>
          <Button
            theme='#28a745'
            icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
            width='70px'
            height='26px'
            disabled={ Object.keys(invalid).length > 0 }
            onClick={ () => {
              resetState()
              createEmployee(detailState)
            } }
          >
            Save
          </Button>
          <Button
            theme='#6c757d'
            width='70px'
            height='26px'
            onClick={ () => {
              resetState()
              setIsCreate(false)
            } }
          >
            Close
          </Button>
        </ButtonGroup>
      </Footer>
    </Modal>
  )
}

const Modal = styled(AntModal)`
  max-width: 100%;
  display: flex;
  justify-content: center;

  .modal-content {
      width: 800px;
  }
`

const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px 10px 16px;
`

const Footer = styled.div`
    height: 42px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #F9F9F9;
    padding: 0 16px;
`

const ButtonGroup = styled.div`
  display: flex;

  div:nth-child(1) {
    margin-right: 12px;
  }
`

const Header = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #333333;
`




// WEBPACK FOOTER //
// ./src/components/new-employee/create-form/index.js